// See https://invis.io/MFCX32YQJ#/246970703_Style_Guide_-_Typography

// Font families
export const fontBase: string = 'sans-serif'
export const fontDemi: string = `Avenir Next LT W01 Demi, ${fontBase}`
export const fontRegular: string = `AvenirNextLTW01-Regular, ${fontBase}`
export const fontMedium: string = `AvenirNextLTW01-Medium, ${fontBase}`

// Font sizes
export const fontSizeBase: number = 16
export const fontScale: number = 1.25


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/styles/typography.ts